import { ApiParameter, get, post } from "@insite/client-framework/Services/ApiService";
import uniqueId from "@insite/mobius/utilities/uniqueId";
import { QuoteTerms } from "@tKgpco/Store/Data/Terms/TermsState";

const rmaUrl = "/api/v1/rmaorders";
const rmaUpdateStatusUrl = "/api/v1/rmaorders/UpdateStatus";
const rmaReportUrl = "/api/v2/report/rmahistory";

export interface RMAReportParam extends ApiParameter {
    rmaNumber?: string;
    poNumber?: string;
    fromDate?: string;
    toDate?: string;
    status?: string;
}

export interface RMACollectionParam extends ApiParameter {
    orderNumber?: string;
    rmaNumber?: string;
    poNumber?: string;
    search?: string;
    status?: string[];
    customerSequence?: string;
    fromDate?: string;
    toDate?: string;
    orderTotal?: string;
    orderTotalOperator?: string;
    productErpNumber?: string;
    page?: number;
    pageSize?: number;
    defaultPageSize?: number;
    sort?: string;
    showMyOrders?: boolean;
    properties?: { [key: string]: string | number | boolean };
    isValid?: boolean;
    validationMessage?: string;
    uniqueId?: string;
}

export interface RMACollectionResult {
    uri: string;
    rmaOrders: RmaOrder[];
    pagination: Pagination;
    properties: Properties3;
}

export interface RmaOrder {
    uri: string;
    rMAHistoryLines: RMahistoryLine[];
    currencySymbol: string;
    statusDisplay: string;
    returnCode: string;
    returnAuthCode: string;
    issueDate: string;
    expirationDate: string;
    returnType: string;
    vendorCode: string;
    stage: string;
    poNumber: string;
    poSystemOrigin: string;
    shipFrom: string;
    shipFromName: string;
    buyerCode: string;
    buyerRegion: string;
    username: string;
    reasonCode: string;
    creditMemo: string;
    creditLineTotal: number;
    creditDateReceived: string;
    vendorLineRestockCharge: number;
    customerRestockCharge: number;
    returnDetailId: string;
    buyerEmail: string;
    closedDate: string;
    status: string;
    assignedTo: string;
    poLineNumber: string;
    itemId: string;
    partNumber: string;
    createdOn: string;
    properties: Properties2;
}

export interface RMahistoryLine {
    uri: string;
    rmaHistoryId: string;
    productUri: string;
    isActiveProduct: boolean;
    priceDisplay: string;
    poLineNumber: string;
    itemId: string;
    partNumber: string;
    qtyRequested: number;
    qtyAuthorized: number;
    qtyReturned: number;
    qtyCredited: number;
    unitPrice: number;
    properties: Properties;
}

export interface Properties {}

export interface Properties2 {}

export interface Pagination {
    currentPage: number;
    page: number;
    pageSize: number;
    defaultPageSize: number;
    totalItemCount: number;
    numberOfPages: number;
    pageSizeOptions: number[];
    sortOptions: SortOption[];
    sortType: string;
    nextPageUri: string;
    prevPageUri: string;
    nextPageToken: string;
}

export interface SortOption {
    displayName: string;
    sortType: string;
}

export interface Properties3 {}

export interface UpdateRMAApiParameter {
    returnCode: string;
    status?: string;
    closedDate?: string;
    creditMemo?: string;
}
export interface RMADetailsParam extends ApiParameter {
    rmaNumber: string;
}

export interface RMADetailsResult {
    uri: any;
    rMAHistoryLines: RMahistoryLine[];
    currencySymbol: string;
    statusDisplay: any;
    returnCode: string;
    returnAuthCode: any;
    issueDate: any;
    expirationDate: any;
    returnType: string;
    vendorCode: string;
    stage: string;
    poNumber: string;
    poSystemOrigin: string;
    shipFrom: any;
    shipFromName: string;
    buyerCode: string;
    buyerRegion: string;
    username: string;
    reasonCode: string;
    creditMemo: any;
    creditLineTotal: number;
    creditDateReceived: any;
    vendorLineRestockCharge: number;
    customerRestockCharge: number;
    returnDetailId: string;
    buyerEmail: string;
    closedDate: any;
    status: any;
    assignedTo: any;
    poLineNumber: any;
    itemId: any;
    partNumber: any;
    createdOn: string;
    properties: Properties2;
}

export interface RMahistoryLine {
    uri: string;
    rmaHistoryId: string;
    productUri: string;
    isActiveProduct: boolean;
    priceDisplay: string;
    mediumImagePath: string;
    poLineNumber: string;
    itemId: string;
    partNumber: string;
    qtyRequested: number;
    qtyAuthorized: number;
    qtyReturned: number;
    qtyCredited: number;
    unitPrice: number;
    properties: Properties;
    productTitle: string;
    brandName: string;
}

export interface Properties {}

export interface Properties2 {}

export const getRMACollection = async (parameters: RMACollectionParam) => {
    const response = await get<RMACollectionResult>(rmaUrl, {
        ...parameters,
        uniqueId: uniqueId(),
    } as RMACollectionParam);
    return response;
};

export const getRMADetails = async (parameters: RMADetailsParam) => {
    const response = await get<RMADetailsResult>(
        `${rmaUrl}/${parameters.rmaNumber}?&expand=orderLines&uniqueId=${uniqueId()}`,
    );
    return response;
};

export const updateRMAStatus = async (parameters: UpdateRMAApiParameter) => {
    const response = await post<UpdateRMAApiParameter>(rmaUpdateStatusUrl, parameters);
    return response;
};

export const getRMAReport = async (parameters: RMAReportParam) => {
    const response = await get<any>(rmaReportUrl, parameters);
    return response;
};
